import { Pipe, PipeTransform } from "@angular/core";
import { DecoratedDocumentRendition, Document, documentRenditions } from "common";

/**
 * Maps one logical document entry to its decorated download options (icon + tooltip per rendition).
 * A statement returns two renditions (PDF + XLSX, paired server-side by group id); other documents
 * return one. Pure, so it only recomputes when the row reference changes (RYNO-14664).
 */
@Pipe({
  name: "documentRenditions",
  standalone: false,
})
export class DocumentRenditionsPipe implements PipeTransform {
  transform(document: Document): DecoratedDocumentRendition[] {
    return documentRenditions(document);
  }
}
